// 引入所需全局组件
import Vue from 'vue'
import 'wt-ui/lib/less/common.less'
import ptPageTitle from 'cps/base/pt-page-title'
import ptTimeSlot from 'cps/base/pt-time-slot'
import ptPageMenuFilter from 'cps/base/pt-page-menu-filter'
import ptPageFactorFilter from 'cps/base/pt-page-factor-filter'
import ptPriceSlot from 'cps/base/pt-price-slot'
import ptFormItem from 'cps/base/pt-form-item'
import ptSubTitle from 'cps/base/pt-sub-title'
import ptSubTitleTab from 'cps/base/pt-sub-title-tab'
import ptFormListItem from 'cps/base/pt-form-list-item'
import ptPageSearch from 'cps/base/pt-page-search'
import ptLegend from 'cps/base/pt-legend'
import wtTab from 'cps/base/wt-tab'
import ptImg from 'cps/base/pt-img'
import ptMessageTableItem from 'cps/base/pt-message-table-item'
import ptCopyButton from 'cps/base/pt-copy-button'
import wtImgPreview from 'cps/base/wt-ui/wt-img-preview'
import wtMenuTree from 'cps/base/pt-menu-tree'
import ptMenuTreeItem from 'cps/base/pt-menu-tree-item'

import wtUeditor from 'cps/base/wt-ui/wt-ueditor'
// import ptDialog from 'cps/base/pt-dialog'
// wt-ui
import wtInput from 'cps/base/wt-ui/wt-input'
import wtSteps from 'cps/base/wt-ui/wt-steps'
import wtCheckbox from 'cps/base/wt-ui/wt-checkbox'
// import wtSimditorTextarea from 'cps/base/wt-ui/wt-simditor-textarea'
import wtRadioInput from 'cps/base/wt-ui/wt-radio-input'
import wtListItem from 'cps/base/wt-ui/wt-list-item'
import wtBox from 'cps/base/wt-ui/wt-box'
import wtRadio from 'cps/base/wt-ui/wt-radio'
import wtAutoComplete from 'cps/base/wt-ui/wt-auto-complete'
import wtInputNumber from 'cps/base/wt-ui/wt-input-number'
import wtPagedTable from 'cps/base/wt-ui/wt-paged-table'

import ptSelectList from 'cps/base/pt-select-list'
import ptRadioList from 'cps/base/pt-radio-list'
// wt-ui
import wtUploadFileBase from 'cps/base/wt-ui/wt-upload-file'

import { View, Avatar, Grid, Box } from 'wt-ui'
import { MenuTree, Selector, PagedTable, ReRequestTip, Table, InputNumber, SimditorTextarea, UploadFile } from 'wt-ui/pc'
Vue.use(MenuTree)
Vue.use(Selector)
Vue.use(Avatar)
Vue.use(Grid)
Vue.use(Box)
// Vue.use(PagedTable)
Vue.use(Table)
Vue.use(ReRequestTip)
Vue.use(UploadFile)
Vue.use(InputNumber)
Vue.use(SimditorTextarea)
Vue.use(View)

Vue.component(ptPageTitle.name, ptPageTitle)
Vue.component(ptTimeSlot.name, ptTimeSlot)
Vue.component(ptPriceSlot.name, ptPriceSlot)
Vue.component(ptPageMenuFilter.name, ptPageMenuFilter)
Vue.component(ptPageFactorFilter.name, ptPageFactorFilter)
Vue.component(ptSubTitle.name, ptSubTitle)
Vue.component(ptSubTitleTab.name, ptSubTitleTab)
Vue.component(ptFormListItem.name, ptFormListItem)
Vue.component(ptPageSearch.name, ptPageSearch)
Vue.component(ptImg.name, ptImg)
Vue.component(ptMessageTableItem.name, ptMessageTableItem)
Vue.component(ptCopyButton.name, ptCopyButton)
Vue.component(wtImgPreview.name, wtImgPreview)
Vue.component(wtUploadFileBase.name, wtUploadFileBase)
// Vue.component(ptDialog.name, ptDialog)
Vue.component(wtTab.name, wtTab)
Vue.component(wtInput.name, wtInput)
Vue.component(wtSteps.name, wtSteps)
Vue.component(wtAutoComplete.name, wtAutoComplete)
Vue.component(wtCheckbox.name, wtCheckbox)
// Vue.component(wtSimditorTextarea.name, wtSimditorTextarea)
Vue.component(wtRadioInput.name, wtRadioInput)
Vue.component(wtListItem.name, wtListItem)
Vue.component(wtBox.name, wtBox)
Vue.component(wtRadio.name, wtRadio)
Vue.component(wtInputNumber.name, wtInputNumber)
Vue.component(ptFormItem.name, ptFormItem)
Vue.component(ptLegend.name, ptLegend)
Vue.component(wtMenuTree.name, wtMenuTree)
Vue.component(ptMenuTreeItem.name, ptMenuTreeItem)
Vue.component(ptSelectList.name, ptSelectList)
Vue.component(ptRadioList.name, ptRadioList)
Vue.component(wtUeditor.name, wtUeditor)
Vue.component(wtPagedTable.name, wtPagedTable)
// Vue.component(wtUploadFile.name, wtUploadFile)
